import * as v from 'valibot';
// Hard-coded enumeration of valid feature flags
export const VALID_FEATURE_FLAGS = ['alpha-tester', 'self-signup'];
export const ValidFeatureFlagSchema = v.picklist(VALID_FEATURE_FLAGS);
export const Features = v.record(ValidFeatureFlagSchema, v.optional(v.literal(true)));
//# sourceMappingURL=features.js.map